import React from "react";

const Bash_Top = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Top</h2>
      <p>Interactive process viewer; shows CPU/memory usage.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>top</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>top  # press q to quit
htop (if installed)</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Use top to identify resource-hungry processes.</p>
    </div>
  );
};

export default Bash_Top;
